<template>
  <div class="scancode">
      <el-card>
        <li class="cell_item" @click="testResult">
          <p class="title_tip">
          <span class="cell_label">
            <svg t="1602731278844" class="icon" viewBox="0 0 1047 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8957" width="15" height="15"><path d="M1012.622222 471.299413 34.133333 471.299413C15.291733 471.299413 0 486.591147 0 505.432747 0 524.274347 15.291733 539.56608 34.133333 539.56608L1012.622222 539.56608C1031.463822 539.56608 1046.755556 524.274347 1046.755556 505.432747 1046.755556 486.591147 1031.463822 471.299413 1012.622222 471.299413ZM259.934436 301.945742C241.092836 301.945742 225.801102 317.237476 225.801102 336.079076 225.801102 354.920676 241.092836 370.212409 259.934436 370.212409L786.816569 370.212409C805.658169 370.212409 820.949902 354.920676 820.949902 336.079076 820.949902 317.237476 805.658169 301.945742 786.816569 301.945742L259.934436 301.945742ZM786.82112 708.922027C805.66272 708.922027 820.954453 693.630293 820.954453 674.788693 820.954453 655.947093 805.66272 640.65536 786.82112 640.65536L259.938987 640.65536C241.097387 640.65536 225.805653 655.947093 225.805653 674.788693 225.805653 693.630293 241.097387 708.922027 259.938987 708.922027L786.82112 708.922027ZM692.733724 69.145031 934.306702 69.145031C948.278613 69.145031 959.656391 80.522809 959.656391 94.49472L959.656391 336.067698C959.656391 354.932053 974.948124 370.201031 993.789724 370.201031 1012.65408 370.201031 1027.923058 354.932053 1027.923058 336.067698L1027.923058 94.49472C1027.923058 42.88512 985.939058 0.878364 934.306702 0.878364L692.733724 0.878364C673.892124 0.878364 658.600391 16.170098 658.600391 35.011698 658.600391 53.853298 673.892124 69.145031 692.733724 69.145031ZM52.954453 369.322667C71.796053 369.322667 87.087787 354.030933 87.087787 335.189333L87.087787 93.616356C87.087787 79.644444 98.465564 68.266667 112.437476 68.266667L354.010453 68.266667C372.874809 68.266667 388.143787 52.974933 388.143787 34.133333 388.143787 15.268978 372.874809 0 354.010453 0L112.437476 0C60.827876 0 18.82112 41.984 18.82112 93.616356L18.82112 335.189333C18.82112 354.030933 34.112853 369.322667 52.954453 369.322667ZM993.801102 640.65536C974.959502 640.65536 959.667769 655.947093 959.667769 674.788693L959.667769 916.361671C959.667769 930.333582 948.289991 941.71136 934.31808 941.71136L692.745102 941.71136C673.880747 941.71136 658.611769 957.003093 658.611769 975.844693 658.611769 994.709049 673.880747 1009.978027 692.745102 1009.978027L934.31808 1009.978027C985.92768 1009.978027 1027.934436 967.994027 1027.934436 916.361671L1027.934436 674.788693C1027.934436 655.947093 1012.642702 640.65536 993.801102 640.65536ZM354.021831 941.722738 112.448853 941.722738C98.476942 941.722738 87.099164 930.34496 87.099164 916.373049L87.099164 674.800071C87.099164 655.935716 71.807431 640.666738 52.965831 640.666738 34.101476 640.666738 18.832498 655.935716 18.832498 674.800071L18.832498 916.373049C18.832498 967.982649 60.816498 1009.989404 112.448853 1009.989404L354.021831 1009.989404C372.863431 1009.989404 388.155164 994.697671 388.155164 975.856071 388.155164 957.014471 372.863431 941.722738 354.021831 941.722738Z" p-id="8958" fill="#1afa29"></path></svg>扫码
          </span>
          </p>
          <span class="cell_value">
          服务器配置
          <i class="iconfont right_jiantou">&#xe6cf;</i>
        </span>
        </li>
        <li class="cell_item" @click="toScan" style="-webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);">
          <p class="title_tip">
          <span class="cell_label">
            <svg t="1602731278844" class="icon" viewBox="0 0 1047 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8957" width="15" height="15"><path d="M1012.622222 471.299413 34.133333 471.299413C15.291733 471.299413 0 486.591147 0 505.432747 0 524.274347 15.291733 539.56608 34.133333 539.56608L1012.622222 539.56608C1031.463822 539.56608 1046.755556 524.274347 1046.755556 505.432747 1046.755556 486.591147 1031.463822 471.299413 1012.622222 471.299413ZM259.934436 301.945742C241.092836 301.945742 225.801102 317.237476 225.801102 336.079076 225.801102 354.920676 241.092836 370.212409 259.934436 370.212409L786.816569 370.212409C805.658169 370.212409 820.949902 354.920676 820.949902 336.079076 820.949902 317.237476 805.658169 301.945742 786.816569 301.945742L259.934436 301.945742ZM786.82112 708.922027C805.66272 708.922027 820.954453 693.630293 820.954453 674.788693 820.954453 655.947093 805.66272 640.65536 786.82112 640.65536L259.938987 640.65536C241.097387 640.65536 225.805653 655.947093 225.805653 674.788693 225.805653 693.630293 241.097387 708.922027 259.938987 708.922027L786.82112 708.922027ZM692.733724 69.145031 934.306702 69.145031C948.278613 69.145031 959.656391 80.522809 959.656391 94.49472L959.656391 336.067698C959.656391 354.932053 974.948124 370.201031 993.789724 370.201031 1012.65408 370.201031 1027.923058 354.932053 1027.923058 336.067698L1027.923058 94.49472C1027.923058 42.88512 985.939058 0.878364 934.306702 0.878364L692.733724 0.878364C673.892124 0.878364 658.600391 16.170098 658.600391 35.011698 658.600391 53.853298 673.892124 69.145031 692.733724 69.145031ZM52.954453 369.322667C71.796053 369.322667 87.087787 354.030933 87.087787 335.189333L87.087787 93.616356C87.087787 79.644444 98.465564 68.266667 112.437476 68.266667L354.010453 68.266667C372.874809 68.266667 388.143787 52.974933 388.143787 34.133333 388.143787 15.268978 372.874809 0 354.010453 0L112.437476 0C60.827876 0 18.82112 41.984 18.82112 93.616356L18.82112 335.189333C18.82112 354.030933 34.112853 369.322667 52.954453 369.322667ZM993.801102 640.65536C974.959502 640.65536 959.667769 655.947093 959.667769 674.788693L959.667769 916.361671C959.667769 930.333582 948.289991 941.71136 934.31808 941.71136L692.745102 941.71136C673.880747 941.71136 658.611769 957.003093 658.611769 975.844693 658.611769 994.709049 673.880747 1009.978027 692.745102 1009.978027L934.31808 1009.978027C985.92768 1009.978027 1027.934436 967.994027 1027.934436 916.361671L1027.934436 674.788693C1027.934436 655.947093 1012.642702 640.65536 993.801102 640.65536ZM354.021831 941.722738 112.448853 941.722738C98.476942 941.722738 87.099164 930.34496 87.099164 916.373049L87.099164 674.800071C87.099164 655.935716 71.807431 640.666738 52.965831 640.666738 34.101476 640.666738 18.832498 655.935716 18.832498 674.800071L18.832498 916.373049C18.832498 967.982649 60.816498 1009.989404 112.448853 1009.989404L354.021831 1009.989404C372.863431 1009.989404 388.155164 994.697671 388.155164 975.856071 388.155164 957.014471 372.863431 941.722738 354.021831 941.722738Z" p-id="8958" fill="#1afa29"></path></svg>扫码
          </span>
          </p>
          <span class="cell_value">
          用户信息查询
          <i class="iconfont right_jiantou">&#xe6cf;</i>
        </span>
        </li>

      </el-card>
  </div>
</template>

<script>
import { getQueryVariable, weixinInit } from "@/utils";

export default {
  data() {
    return {
      menuList: [
        {
          title: '服务器配置'
        },

      ]
    };
  },
  mounted() {
    weixinInit(getQueryVariable('state'));
    // wx.ready(()=>{
    //   this.testResult()
    // })
  },
  methods: {
    testResult() {
      console.log('dianji')
      const self = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          console.log(result)
          self.$router.push({
            path: "/getSeverMsg",
            query: {
              id: result,
            },
          });
        }

      });
    },
    toScan() {
      this.$toast('暂未开放')
    }
  }
};
</script>

<style scoped>
  .scancode{
    padding: 2%;
  }
  .cell_item {
    /* height: 50px;
      line-height: 50px; */
    /* display: flex; */
    margin-top: 10px;
    background: #fff;
    justify-content: space-between;
    padding: 0 3%;
    border-bottom: 1px solid #eee8e8;
  }
  .title_tip {
    /* border-bottom: 1px solid #f1f1f1; */
    line-height: 30px;
  }
  .title_tip svg,
  .title_tip span {
    vertical-align: middle;
    margin-bottom: 3px;
    margin-right: 5px;
  }
  .cell_label {
    font-size: 12px;
    display: block;
  }
  .cell_value {
    /* color: #999; */
    display: flex;
    justify-content: space-between;
    margin: 0.8rem 0;
    font-size: 1rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .right_jiantou {
    font-size: 25px;
    clear: both;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/view/yhBind/scanCode.vue